<script>
  import { getContext } from "svelte";
  import { _ as t } from "svelte-i18n";
  import { Icon } from "t2c-components";

  import Timeline from "./TimelineItem.svelte";
  import EventModal from "./EventModal.svelte";

  export let item;

  const formatTime = (time) => {
    return time.substring(0, 5);
  };

  const { open, close } = getContext("simple-modal");
  const handleClick = () => {
    open(EventModal, {
      item: item,
      onClose: () => {
        close();
      },
    });
  };
</script>

<Timeline cliccable {item} on:click={handleClick}>
  <div class="subtitle">
    <Icon inline medium icon="calendar" stroke="#999" fill="#999" />
    <span class="folder">{formatTime(item.eventTime)}</span>
  </div>
  <p class="description">{item.description ? item.description : ""}</p>
</Timeline>

<style>
  .description {
    color: #999;
    font-size: 13px;
  }

  .subtitle {
    margin-top: 6px;
    font-size: 13px;
    color: #999;
    display: flex;
    align-items: center;
  }

  .folder {
    margin-left: 8px;
  }
</style>
